class TabControllerVue extends Vue {
	constructor( args ) {
		if ( args.methods && typeof args.methods.resetData == 'function' ) {
			const data = args.data || {};
			args.methods.resetData.call( data, false );
			args.data = data;
		}
		super( args );
		if ( args.lockUpdates ) {
			this.updateLockLevel = 0;
		}
	}

	getUpdateLockLevel() {
		if ( this.updateLockLevel === undefined ) {
			this.updateLockLevel = 0;
		}
		return this.updateLockLevel;
	}

	lockUpdates(suffix = null) {
		this.updateLockLevel = typeof this.updateLockLevel == 'number' ? this.updateLockLevel + 1 : 1;
		console.log( 'Updates locked (' + this.updateLockLevel + ') ' + suffix );
	}

	unlockUpdates(suffix = null, then = null) {
		if ( typeof this.updateLockLevel != 'number' ) {
			return typeof then == 'function' ? then() : undefined;
		}
		if ( this.updateLockLevel ) {
			--this.updateLockLevel;
			console.log( ( this.updateLockLevel ? 'Updates still locked (' + this.updateLockLevel + ') ' : 'Updates unlocked ' ) + suffix );
		} else {
			console.log( 'Updates are already unlocked ' + suffix );
		}
		if ( typeof then == 'function' ) { return then(); }
	}

	unlockUpdatesLater(suffix = null, then = null) {
		if ( typeof this.updateLockLevel != 'number' ) {
			if ( typeof then == 'function' ) { setImmediate( then ); }
		} else {
			setImmediate( () => this.unlockUpdates(suffix, then) );
		}
	}

	// Restore data to initial values and call this.onReset if it is a function
	reset(then = null) {
		if ( typeof this.$options.data == 'function' ) {
			if ( typeof this.updateLockLevel == 'number' ) {
				this.lockUpdates( 'reset' );
			}
			// Reset data to the same values as options
			if ( typeof this.resetData == 'function' ) {
				this.resetData();
			}
			if ( typeof this.onReset == 'function' ) {
				this.onReset();
			}
			if ( typeof this.updateLockLevel == 'number' ) {
				this.unlockUpdatesLater( 'reset', then );
			}
		}
	}

	// (Vue object).onCloseTab() will call (Vue object).reset() by default
	onCloseTab() {
		this.reset();
	}

}